export default [
  {
    name: 'Sports',
    path: 'sports',
    meta: { isFooterHidden: true, isHeaderSliderNotSticky: true },
    component: () => import('src/pages/Sports.vue'),
  },
  {
    name: 'bet_refund',
    path: 'bet_refund',
    meta: { isHeaderSliderHidden: true },
    component: () => import('src/pages/BetRefund.vue'),
  },
  {
    name: 'sgtv_bonus',
    path: 'sgtv_bonus',
    component: () => import('src/pages/SgtvBonus.vue'),
  },
  {
    name: 'free_bet_sport',
    path: 'free_bet_sport',
    component: () => import('src/pages/BonusSport.vue'),
  },
  {
    name: 'combo_boost_bonus',
    path: 'combo_boost_bonus',
    component: () => import('src/pages/comboBoostBonus'),
  },
  {
    name: 'no_risk_bet',
    path: 'no_risk_bet',
    component: () => import('src/pages/NoRiskBet.vue'),
  },
  {
    name: 'freeBet',
    path: 'freebet',
    component: () => import('pages/Freebet.vue'),
  },
  {
    name: 'bettingRace',
    path: 'betting_race',
    component: () => import('pages/BettingRace.vue'),
  },
  {
    path: 'apps/:os?',
    name: 'apps',
    meta: { auth: false },
    component: () => import('src/pages/apps'),
  },
]
